import { render } from "./DBlog-C.vue?vue&type=template&id=e9e4221e&scoped=true"
import script from "./DBlog-C.vue?vue&type=script&lang=js"
export * from "./DBlog-C.vue?vue&type=script&lang=js"

import "./DBlog-C.vue?vue&type=style&index=0&id=e9e4221e&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e4221e"]])

export default __exports__